/* Used in legacy code */
export class DeviceBreakout
{
desktop: number;
mobile: number;
}
